/**
 * Do not edit directly
 * Generated on Tue, 01 Aug 2023 18:39:26 GMT
 */
export default `
  :root {
    --jh-z-index-positive-1000: 1000;
    --jh-z-index-positive-900: 900;
    --jh-z-index-positive-800: 800;
    --jh-z-index-positive-700: 700;
    --jh-z-index-positive-600: 600;
    --jh-z-index-positive-500: 500;
    --jh-z-index-positive-400: 400;
    --jh-z-index-positive-300: 300;
    --jh-z-index-positive-200: 200;
    --jh-z-index-positive-100: 100;
    --jh-z-index-negative-100: -100;
    --jh-z-index-0: 0;
    --jh-space-2400: 96px;
    --jh-space-2300: 92px;
    --jh-space-2200: 88px;
    --jh-space-2100: 84px;
    --jh-space-2000: 80px;
    --jh-space-1900: 76px;
    --jh-space-1800: 72px;
    --jh-space-1700: 68px;
    --jh-space-1600: 64px;
    --jh-space-1500: 60px;
    --jh-space-1400: 56px;
    --jh-space-1300: 52px;
    --jh-space-1200: 48px;
    --jh-space-1100: 44px;
    --jh-space-1000: 40px;
    --jh-space-900: 36px;
    --jh-space-800: 32px;
    --jh-space-700: 28px;
    --jh-space-600: 24px;
    --jh-space-500: 20px;
    --jh-space-400: 16px;
    --jh-space-300: 12px;
    --jh-space-200: 8px;
    --jh-space-100: 4px;
    --jh-space-50: 2px;
    --jh-space-0: 0px;
    --jh-size-2400: 96px;
    --jh-size-2300: 92px;
    --jh-size-2200: 88px;
    --jh-size-2100: 84px;
    --jh-size-2000: 80px;
    --jh-size-1900: 76px;
    --jh-size-1800: 72px;
    --jh-size-1700: 68px;
    --jh-size-1600: 64px;
    --jh-size-1500: 60px;
    --jh-size-1400: 56px;
    --jh-size-1300: 52px;
    --jh-size-1200: 48px;
    --jh-size-1100: 44px;
    --jh-size-1000: 40px;
    --jh-size-900: 36px;
    --jh-size-800: 32px;
    --jh-size-700: 28px;
    --jh-size-600: 24px;
    --jh-size-500: 20px;
    --jh-size-400: 16px;
    --jh-size-300: 12px;
    --jh-size-200: 8px;
    --jh-size-100: 4px;
    --jh-size-50: 2px;
    --jh-size-0: 0px;
    --jh-shadow-0: none;
    --jh-opacity-900: 0.9;
    --jh-opacity-800: 0.8;
    --jh-opacity-700: 0.7;
    --jh-opacity-600: 0.6;
    --jh-opacity-500: 0.5;
    --jh-opacity-400: 0.4;
    --jh-opacity-300: 0.3;
    --jh-opacity-200: 0.2;
    --jh-opacity-100: 0.1;
    --jh-opacity-0: 0;
    --jh-font-size-2300: 92px;
    --jh-font-size-2100: 84px;
    --jh-font-size-1900: 76px;
    --jh-font-size-1700: 68px;
    --jh-font-size-1500: 60px;
    --jh-font-size-1350: 54px;
    --jh-font-size-1200: 48px;
    --jh-font-size-1050: 42px;
    --jh-font-size-900: 36px;
    --jh-font-size-800: 32px;
    --jh-font-size-700: 28px;
    --jh-font-size-600: 24px;
    --jh-font-size-500: 20px;
    --jh-font-size-450: 18px;
    --jh-font-size-400: 16px;
    --jh-font-size-350: 14px;
    --jh-font-size-300: 12px;
    --jh-font-size-250: 10px;
    --jh-font-weight-700: 700;
    --jh-font-weight-500: 500;
    --jh-font-weight-400: 400;
    --jh-font-weight-300: 300;
    --jh-font-line-height-2700: 108px;
    --jh-font-line-height-2500: 100px;
    --jh-font-line-height-2300: 92px;
    --jh-font-line-height-2000: 80px;
    --jh-font-line-height-1800: 72px;
    --jh-font-line-height-1600: 64px;
    --jh-font-line-height-1500: 60px;
    --jh-font-line-height-1300: 52px;
    --jh-font-line-height-1100: 44px;
    --jh-font-line-height-1000: 40px;
    --jh-font-line-height-900: 36px;
    --jh-font-line-height-800: 32px;
    --jh-font-line-height-700: 28px;
    --jh-font-line-height-600: 24px;
    --jh-font-line-height-500: 20px;
    --jh-font-line-height-400: 16px;
    --jh-font-line-height-300: 12px;
    --jh-font-family-mono: 'Roboto Mono', monospace;
    --jh-font-family-sans: 'Roboto Flex', Roboto, Helvetica, Arial, sans-serif;
    --jh-border-radius-circle: 50%;
    --jh-border-radius-400: 16px;
    --jh-border-radius-300: 12px;
    --jh-border-radius-200: 8px;
    --jh-border-radius-100: 4px;
    --jh-border-radius-50: 2px;
    --jh-border-radius-0: 0px;
    --jh-shadow-400: 0 16px 24px 0 rgba(0, 0, 0, var(--jh-opacity-300)), 0 8px 8px 0 rgba(0, 0, 0, var(--jh-opacity-100));
    --jh-shadow-300: 0 12px 18px 0 rgba(0, 0, 0, var(--jh-opacity-300)), 0 6px 6px 0 rgba(0, 0, 0, var(--jh-opacity-100));
    --jh-shadow-200: 0 8px 12px 0 rgba(0, 0, 0, var(--jh-opacity-300)), 0 4px 4px 0 rgba(0, 0, 0, var(--jh-opacity-100));
    --jh-shadow-100: 0 4px 6px 0 rgba(0, 0, 0, var(--jh-opacity-300)), 0 2px 2px 0 rgba(0, 0, 0, var(--jh-opacity-100));
    --jh-opacity-disabled: var(--jh-opacity-300);
    --jh-font-heading-bold-6: var(--jh-font-weight-700) var(--jh-font-size-900)/var(--jh-font-line-height-1100) var(--jh-font-family-primary);
    --jh-font-heading-bold-5: var(--jh-font-weight-700) var(--jh-font-size-800)/var(--jh-font-line-height-1000) var(--jh-font-family-primary);
    --jh-font-heading-bold-4: var(--jh-font-weight-700) var(--jh-font-size-700)/var(--jh-font-line-height-900) var(--jh-font-family-primary);
    --jh-font-heading-bold-3: var(--jh-font-weight-700) var(--jh-font-size-500)/var(--jh-font-line-height-700) var(--jh-font-family-primary);
    --jh-font-heading-bold-2: var(--jh-font-weight-700) var(--jh-font-size-400)/var(--jh-font-line-height-600) var(--jh-font-family-primary);
    --jh-font-heading-bold-1: var(--jh-font-weight-700) var(--jh-font-size-350)/var(--jh-font-line-height-500) var(--jh-font-family-primary);
    --jh-font-heading-medium-6: var(--jh-font-weight-500) var(--jh-font-size-900)/var(--jh-font-line-height-1100) var(--jh-font-family-primary);
    --jh-font-heading-medium-5: var(--jh-font-weight-500) var(--jh-font-size-800)/var(--jh-font-line-height-1000) var(--jh-font-family-primary);
    --jh-font-heading-medium-4: var(--jh-font-weight-500) var(--jh-font-size-700)/var(--jh-font-line-height-900) var(--jh-font-family-primary);
    --jh-font-heading-medium-3: var(--jh-font-weight-500) var(--jh-font-size-500)/var(--jh-font-line-height-700) var(--jh-font-family-primary);
    --jh-font-heading-medium-2: var(--jh-font-weight-500) var(--jh-font-size-400)/var(--jh-font-line-height-600) var(--jh-font-family-primary);
    --jh-font-heading-medium-1: var(--jh-font-weight-500) var(--jh-font-size-350)/var(--jh-font-line-height-500) var(--jh-font-family-primary);
    --jh-font-heading-regular-6: var(--jh-font-weight-400) var(--jh-font-size-900)/var(--jh-font-line-height-1100) var(--jh-font-family-primary);
    --jh-font-heading-regular-5: var(--jh-font-weight-400) var(--jh-font-size-800)/var(--jh-font-line-height-1000) var(--jh-font-family-primary);
    --jh-font-heading-regular-4: var(--jh-font-weight-400) var(--jh-font-size-700)/var(--jh-font-line-height-900) var(--jh-font-family-primary);
    --jh-font-heading-regular-3: var(--jh-font-weight-400) var(--jh-font-size-500)/var(--jh-font-line-height-700) var(--jh-font-family-primary);
    --jh-font-heading-regular-2: var(--jh-font-weight-400) var(--jh-font-size-400)/var(--jh-font-line-height-600) var(--jh-font-family-primary);
    --jh-font-heading-regular-1: var(--jh-font-weight-400) var(--jh-font-size-350)/var(--jh-font-line-height-500) var(--jh-font-family-primary);
    --jh-font-display-light-3: var(--jh-font-weight-300) var(--jh-font-size-2300)/var(--jh-font-line-height-2700) var(--jh-font-family-primary);
    --jh-font-display-light-2: var(--jh-font-weight-300) var(--jh-font-size-1350)/var(--jh-font-line-height-1600) var(--jh-font-family-primary);
    --jh-font-display-light-1: var(--jh-font-weight-300) var(--jh-font-size-1050)/var(--jh-font-line-height-1300) var(--jh-font-family-primary);
    --jh-font-code-regular-2: var(--jh-font-weight-400) var(--jh-font-size-400)/var(--jh-font-line-height-600) var(--jh-font-family-mono);
    --jh-font-code-regular-1: var(--jh-font-weight-400) var(--jh-font-size-350)/var(--jh-font-line-height-500) var(--jh-font-family-mono);
    --jh-font-body-bold-italic-2: var(--jh-font-weight-700) italic var(--jh-font-size-400)/var(--jh-font-line-height-600) var(--jh-font-family-primary);
    --jh-font-body-bold-italic-1: var(--jh-font-weight-700) italic var(--jh-font-size-350)/var(--jh-font-line-height-500) var(--jh-font-family-primary);
    --jh-font-body-medium-italic-2: var(--jh-font-weight-500) italic var(--jh-font-size-400)/var(--jh-font-line-height-600) var(--jh-font-family-primary);
    --jh-font-body-medium-italic-1: var(--jh-font-weight-500) italic var(--jh-font-size-350)/var(--jh-font-line-height-500) var(--jh-font-family-primary);
    --jh-font-body-regular-italic-2: var(--jh-font-weight-400) italic var(--jh-font-size-400)/var(--jh-font-line-height-600) var(--jh-font-family-primary);
    --jh-font-body-regular-italic-1: var(--jh-font-weight-400) italic var(--jh-font-size-350)/var(--jh-font-line-height-500) var(--jh-font-family-primary);
    --jh-font-body-bold-2: var(--jh-font-weight-700) var(--jh-font-size-400)/var(--jh-font-line-height-600) var(--jh-font-family-primary);
    --jh-font-body-bold-1: var(--jh-font-weight-700) var(--jh-font-size-350)/var(--jh-font-line-height-500) var(--jh-font-family-primary);
    --jh-font-body-medium-2: var(--jh-font-weight-500) var(--jh-font-size-400)/var(--jh-font-line-height-600) var(--jh-font-family-primary);
    --jh-font-body-medium-1: var(--jh-font-weight-500) var(--jh-font-size-350)/var(--jh-font-line-height-500) var(--jh-font-family-primary);
    --jh-font-body-regular-2: var(--jh-font-weight-400) var(--jh-font-size-400)/var(--jh-font-line-height-600) var(--jh-font-family-primary);
    --jh-font-body-regular-1: var(--jh-font-weight-400) var(--jh-font-size-350)/var(--jh-font-line-height-500) var(--jh-font-family-primary);
    --jh-font-helper-bold: var(--jh-font-weight-700) var(--jh-font-size-300)/var(--jh-font-line-height-400) var(--jh-font-family-primary);
    --jh-font-helper-medium: var(--jh-font-weight-500) var(--jh-font-size-300)/var(--jh-font-line-height-400) var(--jh-font-family-primary);
    --jh-font-helper-regular: var(--jh-font-weight-400) var(--jh-font-size-300)/var(--jh-font-line-height-400) var(--jh-font-family-primary);
    --jh-font-micro-bold: var(--jh-font-weight-700) var(--jh-font-size-250)/var(--jh-font-line-height-300) var(--jh-font-family-primary);
    --jh-font-micro-medium: var(--jh-font-weight-500) var(--jh-font-size-250)/var(--jh-font-line-height-300) var(--jh-font-family-primary);
    --jh-font-micro-regular: var(--jh-font-weight-400) var(--jh-font-size-250)/var(--jh-font-line-height-300) var(--jh-font-family-primary);
    --jh-font-family-primary: var(--jh-font-family-sans);
    --jh-color-overlay: rgba(42, 44, 46, var(--jh-opacity-600));
    --jh-color-rose-950: rgb(67, 5, 23);
    --jh-color-rose-900: rgb(85, 15, 34);
    --jh-color-rose-850: rgb(99, 19, 41);
    --jh-color-rose-800: rgb(118, 22, 49);
    --jh-color-rose-750: rgb(134, 26, 57);
    --jh-color-rose-700: rgb(153, 26, 64);
    --jh-color-rose-650: rgb(171, 25, 71);
    --jh-color-rose-600: rgb(191, 20, 78);
    --jh-color-rose-550: rgb(204, 19, 84);
    --jh-color-rose-500: rgb(220, 43, 95);
    --jh-color-rose-450: rgb(242, 73, 115);
    --jh-color-rose-400: rgb(250, 97, 130);
    --jh-color-rose-350: rgb(248, 120, 143);
    --jh-color-rose-300: rgb(249, 142, 158);
    --jh-color-rose-250: rgb(245, 163, 174);
    --jh-color-rose-200: rgb(247, 190, 197);
    --jh-color-rose-150: rgb(240, 207, 210);
    --jh-color-rose-100: rgb(245, 232, 233);
    --jh-color-rose-50: rgb(253, 241, 242);
    --jh-color-magenta-950: rgb(63, 2, 55);
    --jh-color-magenta-900: rgb(80, 14, 70);
    --jh-color-magenta-850: rgb(93, 17, 83);
    --jh-color-magenta-800: rgb(110, 22, 98);
    --jh-color-magenta-750: rgb(127, 23, 113);
    --jh-color-magenta-700: rgb(143, 26, 127);
    --jh-color-magenta-650: rgb(160, 24, 142);
    --jh-color-magenta-600: rgb(177, 26, 157);
    --jh-color-magenta-550: rgb(189, 28, 168);
    --jh-color-magenta-500: rgb(202, 42, 180);
    --jh-color-magenta-450: rgb(229, 71, 205);
    --jh-color-magenta-400: rgb(243, 89, 218);
    --jh-color-magenta-350: rgb(247, 109, 223);
    --jh-color-magenta-300: rgb(252, 130, 230);
    --jh-color-magenta-250: rgb(251, 153, 232);
    --jh-color-magenta-200: rgb(253, 184, 237);
    --jh-color-magenta-150: rgb(250, 201, 239);
    --jh-color-magenta-100: rgb(255, 227, 248);
    --jh-color-magenta-50: rgb(255, 239, 251);
    --jh-color-violet-950: rgb(52, 2, 87);
    --jh-color-violet-900: rgb(69, 8, 110);
    --jh-color-violet-850: rgb(81, 9, 129);
    --jh-color-violet-800: rgb(94, 12, 150);
    --jh-color-violet-750: rgb(109, 20, 170);
    --jh-color-violet-700: rgb(123, 23, 191);
    --jh-color-violet-650: rgb(136, 24, 211);
    --jh-color-violet-600: rgb(150, 30, 231);
    --jh-color-violet-550: rgb(158, 42, 239);
    --jh-color-violet-500: rgb(168, 61, 243);
    --jh-color-violet-450: rgb(189, 95, 254);
    --jh-color-violet-400: rgb(198, 118, 252);
    --jh-color-violet-350: rgb(202, 135, 245);
    --jh-color-violet-300: rgb(210, 152, 246);
    --jh-color-violet-250: rgb(216, 169, 244);
    --jh-color-violet-200: rgb(229, 192, 250);
    --jh-color-violet-150: rgb(232, 207, 246);
    --jh-color-violet-100: rgb(244, 231, 250);
    --jh-color-violet-50: rgb(247, 242, 250);
    --jh-color-blue-950: rgb(20, 18, 101);
    --jh-color-blue-900: rgb(36, 29, 121);
    --jh-color-blue-850: rgb(45, 36, 137);
    --jh-color-blue-800: rgb(55, 44, 154);
    --jh-color-blue-750: rgb(66, 53, 173);
    --jh-color-blue-700: rgb(76, 61, 190);
    --jh-color-blue-650: rgb(85, 69, 209);
    --jh-color-blue-600: rgb(95, 77, 227);
    --jh-color-blue-550: rgb(104, 84, 235);
    --jh-color-blue-500: rgb(108, 96, 239);
    --jh-color-blue-450: rgb(125, 127, 252);
    --jh-color-blue-400: rgb(138, 142, 248);
    --jh-color-blue-350: rgb(152, 155, 245);
    --jh-color-blue-300: rgb(162, 171, 244);
    --jh-color-blue-250: rgb(177, 183, 243);
    --jh-color-blue-200: rgb(199, 203, 249);
    --jh-color-blue-150: rgb(212, 214, 246);
    --jh-color-blue-100: rgb(233, 234, 251);
    --jh-color-blue-50: rgb(243, 243, 252);
    --jh-color-azure-950: rgb(6, 24, 95);
    --jh-color-azure-900: rgb(19, 35, 119);
    --jh-color-azure-850: rgb(25, 42, 137);
    --jh-color-azure-800: rgb(35, 51, 158);
    --jh-color-azure-750: rgb(42, 59, 177);
    --jh-color-azure-700: rgb(51, 67, 196);
    --jh-color-azure-650: rgb(38, 79, 213);
    --jh-color-azure-600: rgb(8, 92, 229);
    --jh-color-azure-550: rgb(22, 101, 235);
    --jh-color-azure-500: rgb(20, 112, 235);
    --jh-color-azure-450: rgb(74, 138, 251);
    --jh-color-azure-400: rgb(92, 154, 252);
    --jh-color-azure-350: rgb(103, 166, 248);
    --jh-color-azure-300: rgb(118, 180, 248);
    --jh-color-azure-250: rgb(134, 193, 248);
    --jh-color-azure-200: rgb(163, 212, 255);
    --jh-color-azure-150: rgb(186, 220, 251);
    --jh-color-azure-100: rgb(218, 238, 255);
    --jh-color-azure-50: rgb(236, 245, 254);
    --jh-color-cyan-950: rgb(3, 35, 44);
    --jh-color-cyan-900: rgb(13, 48, 58);
    --jh-color-cyan-850: rgb(21, 56, 67);
    --jh-color-cyan-800: rgb(27, 67, 80);
    --jh-color-cyan-750: rgb(30, 77, 92);
    --jh-color-cyan-700: rgb(32, 88, 105);
    --jh-color-cyan-650: rgb(36, 97, 116);
    --jh-color-cyan-600: rgb(38, 108, 129);
    --jh-color-cyan-550: rgb(37, 116, 139);
    --jh-color-cyan-500: rgb(27, 128, 154);
    --jh-color-cyan-450: rgb(32, 152, 183);
    --jh-color-cyan-400: rgb(26, 167, 201);
    --jh-color-cyan-350: rgb(24, 178, 215);
    --jh-color-cyan-300: rgb(41, 191, 230);
    --jh-color-cyan-250: rgb(72, 202, 240);
    --jh-color-cyan-200: rgb(118, 220, 253);
    --jh-color-cyan-150: rgb(156, 227, 252);
    --jh-color-cyan-100: rgb(204, 242, 251);
    --jh-color-cyan-50: rgb(232, 247, 247);
    --jh-color-mint-950: rgb(14, 35, 25);
    --jh-color-mint-900: rgb(22, 49, 36);
    --jh-color-mint-850: rgb(23, 58, 42);
    --jh-color-mint-800: rgb(28, 70, 51);
    --jh-color-mint-750: rgb(31, 80, 58);
    --jh-color-mint-700: rgb(32, 91, 65);
    --jh-color-mint-650: rgb(35, 101, 72);
    --jh-color-mint-600: rgb(35, 112, 80);
    --jh-color-mint-550: rgb(23, 121, 84);
    --jh-color-mint-500: rgb(7, 134, 91);
    --jh-color-mint-450: rgb(26, 158, 109);
    --jh-color-mint-400: rgb(20, 173, 119);
    --jh-color-mint-350: rgb(2, 185, 126);
    --jh-color-mint-300: rgb(24, 199, 137);
    --jh-color-mint-250: rgb(52, 211, 149);
    --jh-color-mint-200: rgb(101, 228, 172);
    --jh-color-mint-150: rgb(144, 234, 190);
    --jh-color-mint-100: rgb(192, 248, 219);
    --jh-color-mint-50: rgb(231, 248, 238);
    --jh-color-green-950: rgb(18, 36, 10);
    --jh-color-green-900: rgb(29, 48, 23);
    --jh-color-green-850: rgb(34, 57, 26);
    --jh-color-green-800: rgb(40, 69, 31);
    --jh-color-green-750: rgb(45, 79, 35);
    --jh-color-green-700: rgb(50, 90, 38);
    --jh-color-green-650: rgb(54, 100, 41);
    --jh-color-green-600: rgb(59, 111, 45);
    --jh-color-green-550: rgb(62, 119, 47);
    --jh-color-green-500: rgb(67, 131, 50);
    --jh-color-green-450: rgb(83, 155, 64);
    --jh-color-green-400: rgb(86, 170, 65);
    --jh-color-green-350: rgb(87, 182, 64);
    --jh-color-green-300: rgb(95, 196, 69);
    --jh-color-green-250: rgb(106, 209, 80);
    --jh-color-green-200: rgb(136, 226, 110);
    --jh-color-green-150: rgb(169, 231, 148);
    --jh-color-green-100: rgb(209, 245, 195);
    --jh-color-green-50: rgb(236, 247, 231);
    --jh-color-lime-950: rgb(27, 34, 8);
    --jh-color-lime-900: rgb(37, 47, 17);
    --jh-color-lime-850: rgb(44, 55, 20);
    --jh-color-lime-800: rgb(54, 67, 26);
    --jh-color-lime-750: rgb(61, 76, 28);
    --jh-color-lime-700: rgb(69, 87, 30);
    --jh-color-lime-650: rgb(76, 96, 33);
    --jh-color-lime-600: rgb(84, 106, 36);
    --jh-color-lime-550: rgb(88, 115, 31);
    --jh-color-lime-500: rgb(95, 127, 28);
    --jh-color-lime-450: rgb(113, 150, 33);
    --jh-color-lime-400: rgb(123, 165, 33);
    --jh-color-lime-350: rgb(131, 176, 31);
    --jh-color-lime-300: rgb(142, 189, 38);
    --jh-color-lime-250: rgb(154, 201, 55);
    --jh-color-lime-200: rgb(179, 218, 95);
    --jh-color-lime-150: rgb(199, 225, 139);
    --jh-color-lime-100: rgb(226, 241, 190);
    --jh-color-lime-50: rgb(241, 246, 229);
    --jh-color-yellow-950: rgb(38, 31, 4);
    --jh-color-yellow-900: rgb(51, 42, 13);
    --jh-color-yellow-850: rgb(61, 50, 12);
    --jh-color-yellow-800: rgb(72, 59, 15);
    --jh-color-yellow-750: rgb(84, 69, 17);
    --jh-color-yellow-700: rgb(95, 79, 19);
    --jh-color-yellow-650: rgb(105, 87, 22);
    --jh-color-yellow-600: rgb(116, 97, 24);
    --jh-color-yellow-550: rgb(125, 104, 21);
    --jh-color-yellow-500: rgb(138, 115, 24);
    --jh-color-yellow-450: rgb(162, 136, 35);
    --jh-color-yellow-400: rgb(177, 149, 36);
    --jh-color-yellow-350: rgb(190, 158, 31);
    --jh-color-yellow-300: rgb(204, 171, 40);
    --jh-color-yellow-250: rgb(216, 182, 59);
    --jh-color-yellow-200: rgb(233, 202, 101);
    --jh-color-yellow-150: rgb(236, 213, 149);
    --jh-color-yellow-100: rgb(248, 234, 199);
    --jh-color-yellow-50: rgb(249, 243, 231);
    --jh-color-orange-950: rgb(44, 28, 4);
    --jh-color-orange-900: rgb(59, 39, 15);
    --jh-color-orange-850: rgb(70, 46, 17);
    --jh-color-orange-800: rgb(82, 55, 20);
    --jh-color-orange-750: rgb(96, 64, 24);
    --jh-color-orange-700: rgb(110, 72, 24);
    --jh-color-orange-650: rgb(122, 80, 25);
    --jh-color-orange-600: rgb(136, 88, 24);
    --jh-color-orange-550: rgb(147, 93, 17);
    --jh-color-orange-500: rgb(164, 103, 12);
    --jh-color-orange-450: rgb(191, 122, 23);
    --jh-color-orange-400: rgb(207, 135, 34);
    --jh-color-orange-350: rgb(219, 145, 44);
    --jh-color-orange-300: rgb(232, 158, 62);
    --jh-color-orange-250: rgb(240, 171, 88);
    --jh-color-orange-200: rgb(252, 193, 127);
    --jh-color-orange-150: rgb(245, 208, 169);
    --jh-color-orange-100: rgb(251, 232, 213);
    --jh-color-orange-50: rgb(250, 242, 235);
    --jh-color-red-950: rgb(57, 19, 7);
    --jh-color-red-900: rgb(78, 26, 15);
    --jh-color-red-850: rgb(96, 27, 14);
    --jh-color-red-800: rgb(119, 25, 13);
    --jh-color-red-750: rgb(139, 21, 10);
    --jh-color-red-700: rgb(158, 21, 11);
    --jh-color-red-650: rgb(174, 24, 13);
    --jh-color-red-600: rgb(189, 33, 19);
    --jh-color-red-550: rgb(202, 37, 21);
    --jh-color-red-500: rgb(219, 53, 32);
    --jh-color-red-450: rgb(241, 81, 53);
    --jh-color-red-400: rgb(249, 103, 73);
    --jh-color-red-350: rgb(249, 123, 94);
    --jh-color-red-300: rgb(250, 145, 118);
    --jh-color-red-250: rgb(248, 164, 142);
    --jh-color-red-200: rgb(251, 191, 174);
    --jh-color-red-150: rgb(245, 207, 196);
    --jh-color-red-100: rgb(250, 231, 226);
    --jh-color-red-50: rgb(253, 241, 238);
    --jh-color-gray-1000: rgb(0, 0, 0);
    --jh-color-gray-950: rgb(30, 32, 33);
    --jh-color-gray-900: rgb(42, 44, 46);
    --jh-color-gray-850: rgb(49, 52, 55);
    --jh-color-gray-800: rgb(59, 62, 65);
    --jh-color-gray-750: rgb(68, 72, 75);
    --jh-color-gray-700: rgb(78, 81, 85);
    --jh-color-gray-650: rgb(87, 90, 93);
    --jh-color-gray-600: rgb(95, 100, 104);
    --jh-color-gray-550: rgb(102, 107, 111);
    --jh-color-gray-500: rgb(112, 117, 122);
    --jh-color-gray-450: rgb(134, 139, 145);
    --jh-color-gray-400: rgb(147, 153, 159);
    --jh-color-gray-350: rgb(156, 163, 170);
    --jh-color-gray-300: rgb(169, 176, 182);
    --jh-color-gray-250: rgb(182, 187, 192);
    --jh-color-gray-200: rgb(201, 206, 211);
    --jh-color-gray-150: rgb(211, 216, 220);
    --jh-color-gray-100: rgb(231, 236, 240);
    --jh-color-gray-50: rgb(240, 245, 249);
    --jh-color-gray-0: rgb(255, 255, 255);
    --jh-color-interactive-visited: var(--jh-color-violet-600);
    --jh-color-interactive-highlight: var(--jh-color-cyan-100);
    --jh-color-interactive-focus-inner: var(--jh-color-gray-0);
    --jh-color-interactive-focus-outer: var(--jh-color-azure-600);
    --jh-color-content-on-inverse-active: var(--jh-color-gray-1000);
    --jh-color-content-on-inverse-hover: var(--jh-color-gray-1000);
    --jh-color-content-on-inverse-enabled: var(--jh-color-gray-1000);
    --jh-color-content-on-negative-active: var(--jh-color-gray-0);
    --jh-color-content-on-negative-hover: var(--jh-color-gray-0);
    --jh-color-content-on-negative-enabled: var(--jh-color-gray-0);
    --jh-color-content-on-positive-active: var(--jh-color-gray-0);
    --jh-color-content-on-positive-hover: var(--jh-color-gray-0);
    --jh-color-content-on-positive-enabled: var(--jh-color-gray-0);
    --jh-color-content-on-secondary-active: var(--jh-color-gray-0);
    --jh-color-content-on-secondary-hover: var(--jh-color-gray-0);
    --jh-color-content-on-secondary-enabled: var(--jh-color-gray-0);
    --jh-color-content-on-primary-active: var(--jh-color-gray-0);
    --jh-color-content-on-primary-hover: var(--jh-color-gray-0);
    --jh-color-content-on-primary-enabled: var(--jh-color-gray-0);
    --jh-color-content-on-brand-active: var(--jh-color-gray-0);
    --jh-color-content-on-brand-hover: var(--jh-color-gray-0);
    --jh-color-content-on-brand-enabled: var(--jh-color-gray-0);
    --jh-color-content-inverse-active: var(--jh-color-gray-100);
    --jh-color-content-inverse-hover: var(--jh-color-gray-50);
    --jh-color-content-inverse-enabled: var(--jh-color-gray-0);
    --jh-color-content-negative-active: var(--jh-color-red-700);
    --jh-color-content-negative-hover: var(--jh-color-red-650);
    --jh-color-content-negative-enabled: var(--jh-color-red-600);
    --jh-color-content-positive-active: var(--jh-color-green-700);
    --jh-color-content-positive-hover: var(--jh-color-green-650);
    --jh-color-content-positive-enabled: var(--jh-color-green-600);
    --jh-color-content-secondary-active: var(--jh-color-gray-700);
    --jh-color-content-secondary-hover: var(--jh-color-gray-650);
    --jh-color-content-secondary-enabled: var(--jh-color-gray-600);
    --jh-color-content-primary-active: var(--jh-color-gray-1000);
    --jh-color-content-primary-hover: var(--jh-color-gray-950);
    --jh-color-content-primary-enabled: var(--jh-color-gray-900);
    --jh-color-content-brand-active: var(--jh-color-azure-700);
    --jh-color-content-brand-hover: var(--jh-color-azure-650);
    --jh-color-content-brand-enabled: var(--jh-color-azure-600);
    --jh-color-brand-on-gradient-dark: var(--jh-color-gray-0);
    --jh-color-brand-on-gradient-light: var(--jh-color-azure-950);
    --jh-color-brand-on-tertiary: var(--jh-color-azure-950);
    --jh-color-brand-on-secondary: var(--jh-color-gray-0);
    --jh-color-brand-on-primary: var(--jh-color-gray-0);
    --jh-color-brand-gradient-dark: linear-gradient(135deg, var(--jh-color-azure-600) 0%, var(--jh-color-azure-950) 100%);
    --jh-color-brand-gradient-medium: linear-gradient(135deg, var(--jh-color-cyan-200) 0%, var(--jh-color-azure-600) 100%);
    --jh-color-brand-gradient-light: linear-gradient(135deg, var(--jh-color-cyan-50) 0%, var(--jh-color-cyan-200) 100%);
    --jh-color-brand-tertiary: var(--jh-color-cyan-200);
    --jh-color-brand-secondary: var(--jh-color-azure-600);
    --jh-color-brand-primary: var(--jh-color-azure-950);
    --jh-color-divider-inverse: var(--jh-color-gray-0);
    --jh-color-divider-secondary: var(--jh-color-gray-100);
    --jh-color-divider-primary: var(--jh-color-gray-500);
    --jh-color-control-active: var(--jh-color-gray-250);
    --jh-color-control-hover: var(--jh-color-gray-200);
    --jh-color-control-enabled: var(--jh-color-gray-150);
    --jh-color-container-secondary-selected: var(--jh-color-azure-100);
    --jh-color-container-secondary-active: var(--jh-color-gray-100);
    --jh-color-container-secondary-hover: var(--jh-color-gray-0);
    --jh-color-container-secondary-enabled: var(--jh-color-gray-50);
    --jh-color-container-primary-selected: var(--jh-color-azure-50);
    --jh-color-container-primary-active: var(--jh-color-gray-100);
    --jh-color-container-primary-hover: var(--jh-color-gray-50);
    --jh-color-container-primary-enabled: var(--jh-color-gray-0);
    --jh-color-container-page: var(--jh-color-gray-100);
    --jh-shadow-focus: 0 0 0 1px var(--jh-color-interactive-focus-inner), 0 0 0 3px var(--jh-color-interactive-focus-outer);
  }
`;